import axios from 'axios';
import { getApiConfigByEnv } from './apiConfigCca';
import { generateCorrelationId, logError } from '../../../components/global/utils/logger';
import { STORAGE_CONFIG } from '../../../constants/storageConfig';

const config = getApiConfigByEnv();
const axiosInstanceCca = axios.create({
    ...config
});

var getAuthToken = () => {
    var token = sessionStorage.getItem(STORAGE_CONFIG.SESSION_STORAGE.GR_TOKEN);
    return `Bearer ${token}`;
};

axiosInstanceCca.interceptors.request.use(
    req => {
        req.headers = {
            ...req.headers,
            'x-correlation-Id': generateCorrelationId(),
            Authorization: getAuthToken()
        };
        return req;
    },
    err => {
        return Promise.reject(err);
    }
);
axiosInstanceCca.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error?.response?.status >= 500)
            //internal server error
            logError(error?.response, false);
        else {
            logError(error);
            return Promise.reject(error);
        }
    }
);

export default axiosInstanceCca;
